export enum FileIndexShiftMethod {
  All = 'shift_all',
  Common = 'shift_common',
}
